import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import Input from "./input";
import axios from "axios";
const root = createRoot(document.getElementById("react-root"));
root.render(<App />);

function App() {
  axios.defaults.baseURL = `https://mobile.kogo.lk`;
  axios.defaults.headers["X-API-KEY"] = "4jdpBTMlW2wt4YGreU2s8AqajyU0bOfY";
  const [isLoading, setLoading] = useState(false);
  const [stage, setStage] = useState(0);
  const [error, setError] = useState("");
  const [token, setToken] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  async function sendVerifyOTP() {
    setLoading(true);
    try {
      let res = await axios.get(`/api/v1/external/verify?phone=${phone}`);
      setToken(res.data.verifyToken);
      setStage(1);
    } catch (error) {
      setError("Something went wrong");
    }
    setLoading(false);
  }
  async function deleteAccount() {
    setLoading(true);
    try {
      let res = await axios.delete(`/api/v1/external/delete`, {
        data: {
          phone: phone,
          code: code,
          verifyToken: token,
        },
      });
      setStage(2);
    } catch (error) {
      setError("Something went wrong");
    }
    setLoading(false);
  }
  return (
    <div>
      <div className="delete-container">
        <div className="delete-container-inner">
          <div className="del-head">Delete Account</div>

          <div className="form-body">
            {stage === 0 ? (
              <>
                <div className="del-info">
                  If you delete your account, you'll lose access to this app and
                  all your info here. Are you sure you want to keep going? Once
                  you delete your account, you can't get your account back.
                </div>
                <Input
                  label="Enter your phone number"
                  id="del_acc_phn"
                  placeholder="07XXXXXXXX"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setError("");
                  }}
                />
                {error ? <div className="error-msg">{error}</div> : null}
                <button
                  className="button"
                  onClick={sendVerifyOTP}
                  style={{ marginTop: 10 }}
                >
                  {isLoading ? (
                    <div className="loader-spinner small"></div>
                  ) : (
                    <>Continue</>
                  )}
                </button>
              </>
            ) : stage === 1 ? (
              <>
                <div className="del-info">
                  If you delete your account, you'll lose access to this app and
                  all your info here. Are you sure you want to keep going? Once
                  you delete your account, you can't get your account back.
                </div>
                <Input
                  label="Enter verification code"
                  id="verify_code"
                  placeholder="XXXXXX"
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value);
                    setError("");
                  }}
                />
                {error ? <div className="error-msg">{error}</div> : null}
                <button
                  className="button"
                  onClick={deleteAccount}
                  style={{ marginTop: 10 }}
                >
                  {isLoading ? (
                    <div className="loader-spinner small"></div>
                  ) : (
                    <>Delete Account</>
                  )}
                </button>
              </>
            ) : stage === 2 ? (
              <div>
                Your account will be deleted shortly. Thank you for staying with
                us.
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
